export default class ColorCart {
  constructor(irodamabtn) {
    this.$ = irodamabtn;
    this.jancode = this.$.closest('.js-zaiko').dataset.shohincd;
    this.clickID = this.$.closest('.js-zaiko').dataset.clickid;

    this.irodamaZaikoContainer = this.$.closest('.js-zaiko');
    this.container = this.$.closest('.js-colorcart');
    this.irodamas = Array.from(this.container.querySelectorAll('.js-colorcart-irodama'));
    this.selectClass = 'm-selected';
    this.colorname = this.$.querySelector('img').getAttribute('src').split('/').pop().slice(0,-4);
    this.cart = this.container.querySelector('.js-colorcart-cart');
    this.display = this.container.querySelector('.js-colorcart-display');
    this.displayClass = this.display.getAttribute('class');
    this.btns = this.container.querySelector('.js-colorcart-cartbtn');
    this.btnDef = this.container.querySelector('.js-colorcart-btn-default');
    this.cartbtns = Array.from(this.container.querySelectorAll('.js-colorcart-link'))
    this.bind();
  }

  bind() {
    this.$.addEventListener('click', this.irodamaClick.bind(this));
  }

  irodamaClick(){
    this.display.setAttribute('class',this.displayClass);
    this.display.classList.add(this.colorname);

    for(let i = 0; i < this.irodamas.length; i++){
      this.irodamas[i].classList.remove(this.selectClass);
    }
    this.$.classList.add(this.selectClass);
    this.linkSet();
    let zaikoTarget = '.zaikokbn' + this.irodamaZaikoContainer.dataset.zaiko;
    this.btnDef.style.display = 'none';
    this.btns.querySelector('.zaikokbn1').style.display = 'none';
    this.btns.querySelector('.zaikokbn2').style.display = 'none';
    this.btns.querySelector('.zaikokbn0').style.display = 'none';
    this.btns.querySelector('.zaikokbn9').style.display = 'none';
    this.btns.querySelector(zaikoTarget).style.display = 'block';
  }

  linkSet(){
    //.js-colorcart-linkにカートリンク設置
    let itemCartParam = '%26sweb_shohin_cd%3D' + this.jancode;
    let cartUrl = '/sw/auth/SWFG014120.seam?brc=brac011&_kss_next_url=%2Fsw%2Fproducts%2Fauth%2FSWFG070220.seam%3FactionMethod%3D%2Fproducts%252Fauth%252FSWFG070220.xhtml%253AsWFG070220Action.addCartShohin%26online_shohin_ctlg_kbn%3D1%26keyword_flg%3D1' + String(itemCartParam);
    this.cartbtns.forEach(link => {
      link.setAttribute('href',cartUrl);
    });
    this.cartbtns.forEach(clicklink => {
      clicklink.setAttribute("onclick","_sc.gene_click('" + this.clickID + "','" + cartUrl +"');");
    });
  }

}

